export function SiteFooter() {
	return (
		<footer className="site-footer">
			<div className="site-footer__refs">
				<h4>Referencias</h4>
				<ol>
					<li id="ref1">
						<a
							href="https://suracapulco.mx/impreso/cultura/seleccionan-a-dos-escritores-guerrerenses-para-el-festival-cultural-interfaz-del-issste/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Seleccionan a dos escritores guerrerenses para el Festival Cultural
							Interfaz del ISSSTE (2017/04/17)
						</a>
					</li>
					<li id="ref2">
						<a href="https://buscadorca.uam.mx/" target="_blank" rel="noopener noreferrer">
							Repositorio de Documentos de Colegio Académico de la UAM
						</a>
					</li>
				</ol>
			</div>
			<div className="site-footer__bar">
				<div className="site-footer__copy">
					En memoria de Stefanny Daniela Mora Nieto · 1992–2023
				</div>
				<div className="site-footer__note">Damián y Dorian Quintanar Mora</div>
			</div>
		</footer>
	);
}
